export const READ_MORE_TEXTS = {
    rubrics: 'Перейти в рубрику',
    brandvoice: 'Перейти в блог',
    events: 'Перейти в События',
};
